import { defineComponent as _defineComponent } from 'vue'
import "vue-sonner/style.css";
import { Toaster } from "vue-sonner";

export default /*@__PURE__*/_defineComponent({
  __name: 'AppNotification',
  setup(__props, { expose: __expose }) {
  __expose();


const __returned__ = { get Toaster() { return Toaster } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})